/*
    Методы для работы с геометрией
*/

//TODO: Написать юнит-тесты

/* Определитель 2x2 */
export function det2(a: number, b: number, c: number, d: number): number {
  return a * d - b * c;
}

/*
    Получить точку пересечения двух прямых
*/
export function getLinesIntersectionPoint(firstLine: Line, secondLine: Line): Point | null {
  const dt = det2(firstLine.a, firstLine.b, secondLine.a, secondLine.b);
  if (Math.abs(dt) < 1e-9) return null;
  return {
    x: -det2(firstLine.c, firstLine.b, secondLine.c, secondLine.b) / dt,
    y: -det2(firstLine.a, firstLine.c, secondLine.a, secondLine.c) / dt,
  };
}

/* 
   Получить прямую по двум точкам 
   (y1 - y2)x + (x2 - x1)y + (x1y2 - x2y1) = 0 
*/

export function getLineByPoints(firstPoint: Point, secondPoint: Point): Line {
  return {
    a: firstPoint.y - secondPoint.y,
    b: secondPoint.x - firstPoint.x,
    c: firstPoint.x * secondPoint.y - secondPoint.x * firstPoint.y,
  };
}

/*
    Получить точку пересечения прямой и прямой, образованной по отрезку
*/

export function getLineSegmentIntersectionPoint(line: Line, segment: Segment) {
  const segmentLine = getLineByPoints(segment.firstPoint, segment.secondPoint);
  return getLinesIntersectionPoint(segmentLine, line);
}

/* Получить прямую x = const */

export function getXConstLine(x: number): Line {
  return {a: -1, b: 0, c: x};
}

/*
    Получить точку пересечения вертикальной прямой x=const и прямой, образованной по отрезку
*/
export function getXSegmentIntersectionPoint(x: number, segment: Segment) {
  const xLine = getXConstLine(x);
  return getLineSegmentIntersectionPoint(xLine, segment);
}

/* Точка (x, y) */

export interface Point {
  x: number;
  y: number;
}

/* Прямая линия в виде  Ax + By + C = 0*/

export interface Line {
  a: number;
  b: number;
  c: number;
}

/* Отрезок */

export interface Segment {
  firstPoint: Point;
  secondPoint: Point;
}
